// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__ql-Rj","detailsBorder":"styles_detailsBorder__PAl09"};